export const fixed = (value, points) => {
	return typeof value === 'number' && typeof points === 'number' && (!!value || value === 0) && points >= 0 ? parseFloat(value).toFixed(points) : value;
};
